import { useTheme } from "@mui/material";
import updateDocDataFieldApi from "../../../api/database/updateDocDataFieldApi";

import SecondaryButton from "../../../buttons/SecondaryButton";
import { addActivityLog } from "../../../config/OnlineStatus";

import ReglementArchitecteClient from "../../../folder_modals/ReglementArchitecteClient";
import ReglementConstructor from "../../../folder_modals/ReglementConstructor";
import ReglementConstructorClient from "../../../folder_modals/ReglementConstructorClient";
import ReglementFolder from "../../../folder_modals/ReglementFolder";
import Icon1 from "../../../icons/Icon";
import CustomAccordion from "../../../layout/CustomAccordion";
import DocumentCell from "../../../listviews/DocumentCell";
import DocumentsListView from "../../../listviews/DocumentsListView";
import SmallSpinner from "../../../loading/SmallSpinner";
import { isFolderAdmin } from "../FolderHelpers";
import refreshCounters from "../../../api/refreshCounters";
import { Token } from "@mui/icons-material";
import { getOrRefreshFirebaseToken } from "../../../config/getFirebaseToken";
import { useEffect, useState } from "react";
import getTemporaryUrlV2 from "../../../api/getTemporaryUrlV2";
import ReglementFolderDevis from "../../../folder_modals/ReglementFolderDevis";

export const FolderDocumentsSection = ({
  thermalData,
  xmlData,
  modifthermalData,
  modifthermalXmlData,
  modifthermalPhotoData,
  architecterapportData,
  rapportData,
  documentsarchi,
  documents,
  orgData,
  userData,
  dropped_exists,
  folderData,
  all_repertories,
  handleFetchData,
  transferFiles,
  loadingTransfer,
  setLoadingTransfer,
  overrideId,
  navigateWorkspace,
  setEmailForExpert,
  setEmailForXml,
  setEmailOpen,
  prefix,
  reglement,
  setReglement,
  slots,
  setSlots,
  setPaymentOpen,
  clientData,
  payments,
  setPayments,
  users,
  setFolderData,
  handleClickVariant,
  handleSetReglementDone,
}) => {
  const theme = useTheme();

  const [folder_audit, setFolderAudit] = useState({
    prepare: { documents: [] },
    process: { documents: [] },
    finalised: { documents: [] },
  });

  const handleSetFolderAudit = (documents) => {
    let audit = {
      prepare: {
        documents: documents.filter((doc) => doc.audit_type === "prepare"),
      },
      process: {
        documents: documents.filter((doc) => doc.audit_type === "process"),
      },
      finalised: {
        documents: documents.filter(
          (doc) => !["prepare", "process"].includes(doc.audit_type)
        ),
      },
    };
    setFolderAudit(audit);
  };

  useEffect(() => {
    if (folderData && folderData.folder_type === "audit") {
      handleSetFolderAudit(documents || []);
    }
  }, [folderData]);

  const handleAskExpert = async () => {
    const xml = folderData.xml;
    xml.requested = true;
    await updateDocDataFieldApi(folderData.ref, "xml", xml, prefix);
    setFolderData({ ...folderData, xml: xml });

    await addActivityLog(
      "Demande dépôt XML",
      folderData.ref,
      orgData.id,
      userData.id,
      "xml_requested",
      prefix
    );
    const token = await getOrRefreshFirebaseToken();
    await refreshCounters(token, folderData.id, prefix);

    setEmailForExpert(true);
    setEmailForXml(true);
    setEmailOpen(true);
  };

  const handleCancelModifThermal = async () => {
    await updateDocDataFieldApi(
      folderData.ref,
      "modif_thermal.activated",
      false,
      prefix
    );
    handleClickVariant("Mise à jour annulée", "success");
    handleFetchData();
  };

  const [loadingInvoice, setLoadingInvoice] = useState(false);

  const handleLoadInvoice = async (invoice) => {
    if (invoice.file.id) {
      setLoadingInvoice(invoice.file.id);
      const token = await getOrRefreshFirebaseToken();
      let refreshed_url = await getTemporaryUrlV2(
        invoice.file.id,
        token,
        prefix
      );
      if (refreshed_url) {
        window.open(refreshed_url, "_blank");
      } else {
        handleClickVariant("Impossible de charger le fichier", "error");
      }
      setLoadingInvoice(false);
    }
  };

  const handleRemoveInvoice = async (invoice) => {
    setLoadingInvoice(invoice.file.id);
    let new_invoices = folderData.invoices.filter(
      (inv) => inv.file?.id !== invoice.file?.id
    );
    await updateDocDataFieldApi(
      folderData.ref,
      "invoices",
      new_invoices,
      prefix
    );
    await addActivityLog(
      "Devis supprimé",
      folderData.ref,
      orgData.id,
      userData.id,
      "invoice_deleted",
      prefix
    );

    handleFetchData();
    handleClickVariant("Devis supprimé", "success");
    setLoadingInvoice(false);
  };

  const handleUpdateReglement = async () => {
    await updateDocDataFieldApi(folderData.ref, "reglement", reglement, prefix);
    await addActivityLog(
      "Informations règlement mises à jour",
      folderData.ref,
      orgData.id,
      userData.id,
      "reglement_updated",
      prefix
    );
    handleClickVariant("Règlement mis à jour", "success");
    handleFetchData();
  };

  return (
    <>
      {folderData.folder_type !== "audit" && (
        <>
          <CustomAccordion userData={userData} title="Documents">
            <div className="border-1 border-shadow_10  rounded-md  flex flex-col p-1">
              {folderData.folder_type === "infiltro" && (
                <>
                  <DocumentCell
                    document={xmlData}
                    orgData={orgData}
                    userData={userData}
                    dropped_exists={dropped_exists}
                    folder={folderData}
                    onUpdate={handleFetchData}
                    transferFiles={transferFiles}
                    handleAskExpert={handleAskExpert}
                    loadingTransfer={loadingTransfer}
                    setLoadingTransfer={setLoadingTransfer}
                    overrideId={overrideId}
                    navigateWorkspace={navigateWorkspace}
                  ></DocumentCell>
                  {folderData.thermal?.files?.length > 0 && (
                    <DocumentCell
                      document={thermalData}
                      orgData={orgData}
                      userData={userData}
                      dropped_exists={dropped_exists}
                      folder={folderData}
                      onUpdate={handleFetchData}
                      transferFiles={transferFiles}
                      loadingTransfer={loadingTransfer}
                      setLoadingTransfer={setLoadingTransfer}
                      overrideId={overrideId}
                      navigateWorkspace={navigateWorkspace}
                    ></DocumentCell>
                  )}
                </>
              )}
              <DocumentsListView
                documents={documents}
                orgData={orgData}
                userData={userData}
                dropped_exists={dropped_exists}
                folder={folderData}
                onUpdate={handleFetchData}
                transferFiles={transferFiles}
                loadingTransfer={loadingTransfer}
                setLoadingTransfer={setLoadingTransfer}
                overrideId={overrideId}
                navigateWorkspace={navigateWorkspace}
              ></DocumentsListView>
            </div>
          </CustomAccordion>
          {documentsarchi.length > 0 && (
            <>
              {" "}
              <CustomAccordion title="Documents architecte" userData={userData}>
                <DocumentsListView
                  documents={documentsarchi}
                  orgData={orgData}
                  userData={userData}
                  dropped_exists={dropped_exists}
                  folder={folderData}
                  onUpdate={handleFetchData}
                  transferFiles={transferFiles}
                  loadingTransfer={loadingTransfer}
                  setLoadingTransfer={setLoadingTransfer}
                  overrideId={overrideId}
                  navigateWorkspace={navigateWorkspace}
                ></DocumentsListView>
              </CustomAccordion>
            </>
          )}
          {folderData.modif_thermal?.activated && (
            <>
              <CustomAccordion
                userData={userData}
                title="Mise à jour étude thermique"
              >
                <div className="border-shadow_10 border-1 rounded-md max-w-full">
                  <DocumentCell
                    document={modifthermalData}
                    orgData={orgData}
                    userData={userData}
                    dropped_exists={dropped_exists}
                    folder={folderData}
                    onUpdate={handleFetchData}
                    transferFiles={transferFiles}
                    loadingTransfer={loadingTransfer}
                    setLoadingTransfer={setLoadingTransfer}
                    overrideId={overrideId}
                    navigateWorkspace={navigateWorkspace}
                  ></DocumentCell>
                  <DocumentCell
                    document={modifthermalXmlData}
                    orgData={orgData}
                    userData={userData}
                    dropped_exists={dropped_exists}
                    folder={folderData}
                    onUpdate={handleFetchData}
                    transferFiles={transferFiles}
                    handleAskExpert={handleAskExpert}
                    loadingTransfer={loadingTransfer}
                    setLoadingTransfer={setLoadingTransfer}
                    overrideId={overrideId}
                    navigateWorkspace={navigateWorkspace}
                  ></DocumentCell>

                  <DocumentCell
                    document={modifthermalPhotoData}
                    orgData={orgData}
                    userData={userData}
                    dropped_exists={dropped_exists}
                    folder={folderData}
                    onUpdate={handleFetchData}
                    transferFiles={transferFiles}
                    loadingTransfer={loadingTransfer}
                    setLoadingTransfer={setLoadingTransfer}
                    overrideId={overrideId}
                    navigateWorkspace={navigateWorkspace}
                  ></DocumentCell>
                  <div className="flex flex-col  border-1 m-2  ">
                    <div className="p-2">
                      <div className="flex flex-row gap-2 text-h3 text-shadow_50  ">
                        Membres assignés :{" "}
                        {folderData.modif_thermal?.users_id?.map(
                          (user_id, index) => (
                            <span
                              key={index}
                              className="px-1 py-0.5 bg-blue-100 text-blue-500 rounded-lg"
                            >
                              @
                              {
                                users.find((u) => u.id === user_id)
                                  ?.display_name
                              }
                            </span>
                          )
                        )}
                      </div>
                      <div className="text-h3 text-shadow_50 ">
                        Dernière demande de mise à jour :{" "}
                        {folderData.modif_thermal?.datelastupdate
                          ?.toDate()
                          .toLocaleString()}
                      </div>
                      <div className="text-h3 text-black font-medium mt-3">
                        {folderData.modif_thermal?.object}
                      </div>
                    </div>
                    <div
                      className="text-h3 flex flex-col gap-4 text-shadow_50 mb-2 p-2 border-t-1 "
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      {folderData.modif_thermal?.content}
                      <SecondaryButton
                        className="w-fit"
                        onClick={handleCancelModifThermal}
                      >
                        Annuler la demande
                      </SecondaryButton>{" "}
                    </div>
                  </div>
                </div>
              </CustomAccordion>
            </>
          )}
        </>
      )}
      {folderData.folder_type == "audit" && (
        <>
          <CustomAccordion userData={userData} title="Préparation du projet">
            <div className="border-1 border-shadow_10  rounded-md  flex flex-col p-1">
              <DocumentsListView
                documents={folder_audit.prepare.documents}
                orgData={orgData}
                userData={userData}
                dropped_exists={dropped_exists}
                folder={folderData}
                onUpdate={handleFetchData}
                transferFiles={transferFiles}
                loadingTransfer={loadingTransfer}
                setLoadingTransfer={setLoadingTransfer}
                overrideId={overrideId}
                navigateWorkspace={navigateWorkspace}
              ></DocumentsListView>
            </div>
          </CustomAccordion>
          <CustomAccordion userData={userData} title="Dépôt du dossier">
            <div className="border-1 border-shadow_10  rounded-md  flex flex-col p-1">
              <DocumentsListView
                documents={folder_audit.process.documents}
                orgData={orgData}
                userData={userData}
                dropped_exists={dropped_exists}
                folder={folderData}
                onUpdate={handleFetchData}
                transferFiles={transferFiles}
                loadingTransfer={loadingTransfer}
                setLoadingTransfer={setLoadingTransfer}
                overrideId={overrideId}
                navigateWorkspace={navigateWorkspace}
              ></DocumentsListView>
            </div>
          </CustomAccordion>
          <CustomAccordion userData={userData} title="Finalisation du projet">
            <div className="border-1 border-shadow_10  rounded-md  flex flex-col p-1">
              <DocumentsListView
                documents={folder_audit.finalised.documents}
                orgData={orgData}
                userData={userData}
                dropped_exists={dropped_exists}
                folder={folderData}
                onUpdate={handleFetchData}
                transferFiles={transferFiles}
                loadingTransfer={loadingTransfer}
                setLoadingTransfer={setLoadingTransfer}
                overrideId={overrideId}
                navigateWorkspace={navigateWorkspace}
              ></DocumentsListView>
            </div>
          </CustomAccordion>
        </>
      )}
      {(all_repertories || !folderData.payment_allowed) && (
        <CustomAccordion
          userData={userData}
          title="Rapports à destination du client"
        >
          <div className="border-shadow_10 border-1 rounded-xl">
            {(documentsarchi.length > 0 ||
              folderData.pack_name === "Attestation Conformité tertiaire" ||
              folderData.pack_name === "Attestation Conformité tertiare") && (
              <DocumentCell
                document={architecterapportData}
                orgData={orgData}
                userData={userData}
                dropped_exists={dropped_exists}
                folder={folderData}
                onUpdate={handleFetchData}
                transferFiles={transferFiles}
                loadingTransfer={loadingTransfer}
                setLoadingTransfer={setLoadingTransfer}
                overrideId={overrideId}
              ></DocumentCell>
            )}
            {all_repertories && (
              <DocumentCell
                document={rapportData}
                orgData={orgData}
                userData={userData}
                dropped_exists={dropped_exists}
                folder={folderData}
                onUpdate={handleFetchData}
                transferFiles={transferFiles}
                loadingTransfer={loadingTransfer}
                setLoadingTransfer={setLoadingTransfer}
                overrideId={overrideId}
              ></DocumentCell>
            )}

            {isFolderAdmin(orgData, folderData) && (
              <div className="flex flex-row gap-1 h-fit  w-full">
                <ReglementFolderDevis
                  orgData={orgData}
                  userData={userData}
                  folderData={folderData}
                  prefix={prefix}
                  handleFetchData={handleFetchData}
                  loadingTransfer={loadingTransfer}
                  setLoadingTransfer={setLoadingTransfer}
                  transferFiles={transferFiles}
                  dropped_exists={dropped_exists}
                  navigateWorkspace={navigateWorkspace}
                ></ReglementFolderDevis>
              </div>
            )}
          </div>{" "}
          {isFolderAdmin(orgData, folderData) && (
            <div className="h-fit">
              <ReglementConstructor
                orgData={orgData}
                userData={userData}
                folderData={folderData}
                clientData={clientData}
                reglement={reglement}
                slots={slots}
                setReglement={setReglement}
                setSlots={setSlots}
                setPaymentOpen={setPaymentOpen}
                handleUpdateReglement={handleUpdateReglement}
                handleFetchData={handleFetchData}
                loadingTransfer={loadingTransfer}
                transferFiles={transferFiles}
                setLoadingTransfer={setLoadingTransfer}
                dropped_exists={dropped_exists}
              ></ReglementConstructor>{" "}
            </div>
          )}
          {(all_repertories || orgData.id === folderData.client_id) &&
            !folderData.payment_allowed && (
              <div className="h-fit">
                <ReglementConstructorClient
                  orgData={orgData}
                  userData={userData}
                  folderData={folderData}
                  clientData={clientData}
                  reglement={reglement}
                  slots={slots}
                  setReglement={setReglement}
                  setSlots={setSlots}
                  setPaymentOpen={setPaymentOpen}
                  handleUpdateReglement={handleUpdateReglement}
                  handleFetchData={handleFetchData}
                  loadingTransfer={loadingTransfer}
                  transferFiles={transferFiles}
                  setLoadingTransfer={setLoadingTransfer}
                  dropped_exists={dropped_exists}
                ></ReglementConstructorClient>{" "}
              </div>
            )}
        </CustomAccordion>
      )}

      {all_repertories ||
        (orgData.id === folderData.client_id && folderData.payment_allowed && (
          <CustomAccordion
            userData={userData}
            title="Rapports à destination du client"
          >
            <div className="h-fit">
              <ReglementArchitecteClient
                orgData={orgData}
                userData={userData}
                folderData={folderData}
                clientData={clientData}
                reglement={reglement}
                payments={payments}
                setReglement={setReglement}
                setPayments={setPayments}
                setPaymentOpen={setPaymentOpen}
                handleUpdateReglement={handleUpdateReglement}
                handleFetchData={handleFetchData}
                loadingTransfer={loadingTransfer}
                transferFiles={transferFiles}
                setLoadingTransfer={setLoadingTransfer}
                dropped_exists={dropped_exists}
                navigateWorkspace={navigateWorkspace}
              ></ReglementArchitecteClient>
            </div>
          </CustomAccordion>
        ))}

      {isFolderAdmin(orgData, folderData) && folderData.payment_allowed && (
        <CustomAccordion
          title="Rapports débloqués au paiement particulier"
          userData={userData}
        >
          <div className="h-fit">
            <ReglementFolder
              orgData={orgData}
              userData={userData}
              folderData={folderData}
              clientData={clientData}
              reglement={reglement}
              payments={payments}
              setReglement={setReglement}
              setPayments={setPayments}
              setPaymentOpen={setPaymentOpen}
              handleUpdateReglement={handleUpdateReglement}
              handleFetchData={handleFetchData}
              loadingTransfer={loadingTransfer}
              transferFiles={transferFiles}
              setLoadingTransfer={setLoadingTransfer}
              dropped_exists={dropped_exists}
              navigateWorkspace={navigateWorkspace}
              handleSetReglementDone={handleSetReglementDone}
            ></ReglementFolder>{" "}
          </div>
        </CustomAccordion>
      )}
    </>
  );
};
